import { DefaultModal } from "../../../global/modals/material/DefaultModal";
import { BlogCardFollowProvider } from "./BlogCardFollowProvider";
import { IUserData } from "../../../../interfaces/user/IUserData";
import { BlogCardModalFollow } from "./BlogCardModalFollow";
import { useModalContext } from "../../../global/modals";

type BlogCardModalProps = {
  coach: IUserData;
};

export const BlogCardModal = ({ coach }: BlogCardModalProps) => {
  const { closeModal } = useModalContext();

  return (
    <DefaultModal onClose={closeModal} className={"pt-20"}>
      <BlogCardFollowProvider coach={coach}>
        <BlogCardModalFollow />
      </BlogCardFollowProvider>
    </DefaultModal>
  );
};
